export function preferCallMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      unitProcessorId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdatePreferCallId(json) {
  return {
    data: {...json, id: json.objectId,preferCallId:json.objectId},
  };
}
export function fixGetManyPreferCall(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      categoryId: resource.objectId,
    })),
  };
}

export function fixCreatePreferCallId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function preferCallMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, unitProcessorId: json.result.objectId},
  };
}